import $ from 'jquery';
import * as variables from 'variables';
import sendEventToGoogleAnalytics from 'utils/googleAnalytics';

const scheduleListTemplate = require('schedule-list-template.dust');

export default function displayScheduleCMS(context) {
	function loadDataList(offset) {
		$.getJSON(`${variables.directioCMSapiService}schedule/GetSchedule/${variables._enteRef}?offset=${offset}&count=${variables._itemsToDisplay}&callback=?&t=${new Date().getTime()}`).done((data) => {
			scheduleListTemplate(data, (err, out) => {
				$('.js-schedule-list').append(out);
			});
		}).fail((jqXHR, textStatus, errorThrown) => {
			sendEventToGoogleAnalytics('Client-Error', 'ajax', `${jqXHR.getAllResponseHeaders()} ${textStatus} ${errorThrown.message}`);
		}).always(() => {
			variables.$doc.trigger('view.loaded');
			variables._loadingInProgress = false;
		});
	}

	context.$element().append(document.getElementById('schedule-page-list-template').innerHTML);

	loadDataList(variables._viewPage);

	variables.$doc.trigger('view.scroll.on', [loadDataList]);
}



/** WEBPACK FOOTER **
 ** ./Scripts/libs/utils/displayScheduleCMS.js
 **/